import { render, staticRenderFns } from "./WhySignup.vue?vue&type=template&id=1f98c616&scoped=true&"
import script from "./WhySignup.vue?vue&type=script&lang=js&"
export * from "./WhySignup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f98c616",
  null
  
)

export default component.exports